export const CHARFONT = "'Noto Serif KR'"